export default __webpack_public_path__ + "static/blue-edi-f1c343ba2d4e54a7a2bcc9471b41a8f8.svg";